import {observable} from 'mobx';
import {construct, createArrayInstance, ModelProperties} from 'utils';
import {SeoLocaleKey} from './seo-locale-key';

export class SeoLocaleCategory {
    @observable id!: number;

    @observable name!: string;

    @observable global!: boolean;

    @observable keys?: SeoLocaleKey[];

    constructor(category?: ModelProperties<SeoLocaleCategory>) {
        if (category) {
            construct(this, category);
            this.keys = createArrayInstance(SeoLocaleKey, category.keys);
        }
    }
}